import {
    ViewTemplateId,
    WorkbenchPlugin,
    WorkbenchPluginId,
    WorkbenchViewConfig,
    WorkbenchViewKind,
    WorkbenchViewTemplateConfig
} from '../../shared/types';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {DeviceId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {WorkbenchContextService} from '../../shared/services/workbench-context.service';
import _ from 'lodash';
import {DeviceConsoleViewComponent, DeviceConsoleViewConfig} from './device-console-view.component';
import {faDesktop} from '@fortawesome/pro-light-svg-icons';
import {CENTER_VIEW_CONTAINER_CONFIG, CENTER_VIEW_CONTAINER_ID} from '../../shared/components/viewcontainers/viewcontainers';
import {DevicePropertyName} from '@webmate-web-core/shared/types/devices/device-properties';

@Injectable()
export class ConsolePlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'console';
    projectId: ProjectId;
    views: WorkbenchViewKind[] = [];

    static readonly ViewTemplateId: ViewTemplateId = 'console.console-view-template';

    constructor(readonly layoutManager: WorkbenchLayoutManager,
                private readonly workbenchContextService: WorkbenchContextService) {
        super(layoutManager);
        this.workbenchContextService.subscribeWorkbenchContext$().subscribe(context => {
            this.projectId = context.project;

            const consoleViewTemplate: WorkbenchViewTemplateConfig<DeviceConsoleViewConfig> = {
                templateId: ConsolePlugin.ViewTemplateId,
                component: DeviceConsoleViewComponent,
                icon: {
                    type: 'faIcon',
                    instance: faDesktop
                },
                defaultViewContainer: CENTER_VIEW_CONTAINER_ID,
                popoutConfig: {
                    projectId: this.projectId,
                    consoleIdentifier: 'device-console',
                },

                init: (d: {id: DeviceId, name: string, additionalStartupProperties?: Array<DevicePropertyName>}) => {
                    let config = _.cloneDeep(consoleViewTemplate) as WorkbenchViewConfig<DeviceConsoleViewConfig>;
                    config.id = 'device.view.console.' + d.id;
                    config.fromTemplate = ConsolePlugin.ViewTemplateId;
                    config.name = d.name || 'Device Console';
                    config.popoutConfig = {
                        projectId: this.projectId,
                        consoleIdentifier: config.id,
                        deviceId: d.id,
                    };
                    config.payload = {
                        data: {
                            deviceId: d.id,
                            additionalStartupProperties: d.additionalStartupProperties
                        }
                    };
                    return config as WorkbenchViewConfig<DeviceConsoleViewConfig>;
                }
            };

            this.views = [consoleViewTemplate];
        });
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer(CENTER_VIEW_CONTAINER_CONFIG);
        return of(undefined);
    }

}
